// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, FormFeedback, Input, Progress } from 'reactstrap';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"
import { getHorizontalList, getVerticalList, } from "helpers/backend_api_helper"
import { withTranslation } from "react-i18next";
import toastr from "toastr";
import { 
    getQuestion, 
    listSurvey, 
    saveQuestionAnswer,
    horizontalList,
    verticalList
} from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import SaveContinueModal from "components/_Common/SaveContinueModal";



const PhaseTwo = props => {
    document.title = `${props.t("Survey Phase Two")}  | ${props.t("Participant")}`;
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { state } = useLocation();

    // const { error, success, loading } = useSelector(state => ({
    //     loading: state.Survey.loading,
    //     error: state.Survey.error,
    //     success: state.Survey.success,
    // }));

    const { surveyData, loading, error, successMsg } = useSelector((state) => state.Survey);
    const { horizontalData, horizontalLoading } = useSelector((state) => state.Survey);
    const { verticalData, verticalLoading } = useSelector((state) => state.Survey);



    const [loadingQuestion, setLoadingQuestion] = useState(false);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(state?.prev_two_page_index || 0);
    const [progressBar, setProgressBar] = useState(0);
    const [surveyLength, setSurveyLength] = useState(surveyData?.survey_answers?.length || 0);
    const [selectedValues, setSelectedValues] = useState(Array(5).fill(''));
    const [questions, setQuestions] = useState(surveyData?.survey?.phase_two || []);
    const [nextLoading, setNextLoading] = useState(false);
    const [openSaveContinueModal, setSaveContinueDeleteModal] = useState(false);

   

    useEffect(() => {
        fetchSurveyData()
    }, [location?.key])


    useEffect(() => {

        // if (surveyData?.survey_status == "complete") {
        //     navigate('/save-servey')
        // }

        if (surveyData?.survey?.phase_two) {
            setSurveyLength(surveyData?.survey_answers?.length || 0);
            setProgressBar((Number(surveyLength) / Number(surveyData?.survey_length)) * 100);
            setQuestions(surveyData?.survey?.phase_two || []);
        }

    }, [surveyData, surveyLength]);

    // const [horizontalList, setHorizontalList] = useState();
    // const [verticalList, setVerticalList] = useState();

    const getHorizontal = async () => {
        setLoadingQuestion(true)
        try {
            const list = await getHorizontalList();
            console.log("list?.data", list?.data)
            setHorizontalList(list?.data)
            setLoadingQuestion(false)

        } catch (error) {
            setLoadingQuestion(false)

        }
    }

    const getVertical = async () => {
        setLoadingQuestion(true)

        try {
            const list = await getVerticalList();
            setVerticalList(list?.data);
            setLoadingQuestion(false)

        } catch (error) {
            setLoadingQuestion(false)

        }
    }

    useEffect(() => {
        getHorizontal()
        getVertical()
    }, [])



    const handleNext = () => {
        if (loading || selectedValues.length < 5) {
            return
        }
        if (currentQuestionIndex < questions.length - 1) {
            if (!selectedValues.every(value => value !== '')) {
                toastr.error(props.t("PLEASE FILL ALL ANSWERS."));
                return;
            }
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setSelectedValues(Array(5).fill(''));

            const answer = {};
            selectedValues.forEach((value, index) => {
                answer[`schor_horizontal_${index + 1}`] = value + 1;
            });
            let objValues = {
                "id": questions[currentQuestionIndex]?.id,
                "questionnaire_id": questions[currentQuestionIndex]?.questionnaire_id,
                "page": 1,
                "question_type": questions[currentQuestionIndex]?.question_type,
                "answer": answer
            }
            setNextLoading(true)
            dispatch(saveQuestionAnswer(objValues, "rater", (res) => {
                if (res?.status === 'success') {
                    toastr.clear();
                    toastr.success(res.message)
                    setNextLoading(false)
                    fetchSurveyData()
                    setSurveyLength(surveyData?.survey_answers?.length)
                    setProgressBar((Number(surveyLength) / Number(surveyData?.survey_length)) * 100)
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    });

                } else {
                    toastr.error(res.message)
                }
            }));

        } else {
            if (!selectedValues.every(value => value !== '')) {
                toastr.error(props.t("PLEASE FILL ALL ANSWERS."));
                return;
            }
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setSelectedValues(Array(5).fill(''));

            const answer = {};
            selectedValues.forEach((value, index) => {
                answer[`schor_horizontal_${index + 1}`] = value + 1;
            });
            let objValues = {
                "id": questions[currentQuestionIndex]?.id,
                "questionnaire_id": questions[currentQuestionIndex]?.questionnaire_id,
                "page": 1,
                "question_type": questions[currentQuestionIndex]?.question_type,
                "answer": answer
            }
            setNextLoading(true)
            dispatch(saveQuestionAnswer(objValues, "rater", (res) => {
                if (res?.status === 'success') {
                    toastr.clear();
                    toastr.success(res.message)
                    setNextLoading(false)
                    fetchSurveyData()
                    setSurveyLength(surveyData?.survey_answers?.length)
                    setProgressBar((Number(surveyLength) / Number(surveyData?.survey_length)) * 100)
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    });

                } else {
                    toastr.error(res.message)
                }
            }));
            navigate('/complete-self-servey/phase-three', {
                state: {
                    surveyData: surveyData,
                    prev_two_page_index: currentQuestionIndex
                }
            });

        }
    };

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };


    // Function to handle radio button selection
    const handleRadioChange = (rowIndex, colIndex) => {
        const newSelectedValues = [...selectedValues];
        newSelectedValues[rowIndex] = colIndex;
        setSelectedValues(newSelectedValues);
    };

    const fetchSurveyData = () => {

        dispatch(listSurvey("rater"));
        dispatch(horizontalList());
        dispatch(verticalList());
    }

    const saveAnswer = () => {
        const filteredSelectedValues = selectedValues.filter(item => item !== '');
        const length = filteredSelectedValues.length;
        if (length == 0) {
            navigate("/save-servey")
            return;
        }

        if (length < 5 && length > 0) {
            setSaveContinueDeleteModal(true);
            return;
        }

        if (!selectedValues.every(value => value !== '')) {
            toastr.error(props.t("PLEASE FILL ALL ANSWERS."));
            return;
        }
        const answer = {};

        selectedValues.forEach((value, index) => {
            answer[`schor_horizontal_${index + 1}`] = value + 1;
        });
        let objValues = {
            "id": questions[currentQuestionIndex]?.id,
            "questionnaire_id": questions[currentQuestionIndex]?.questionnaire_id,
            "page": 1,
            "question_type": questions[currentQuestionIndex]?.question_type,
            "answer": answer
        }

        dispatch(saveQuestionAnswer(objValues, "rater", (res) => {
            if (res?.status === 'success') {
                fetchSurveyData()
                navigate("/save-servey")
            } else {
                toastr.error(res.message)
            }
        }));
    }

    const getQuestionById = async (id) => {
        dispatch(getQuestion(id, "rater", (res) => {
            if (res?.status === 'success') {
                const keysToCheck = ["schor_horizontal_1", "schor_horizontal_2", "schor_horizontal_3", "schor_horizontal_4", "schor_horizontal_5"];
                const valuesArray = [];
                keysToCheck.forEach(key => {
                    if (res?.data.hasOwnProperty(key)) {
                        valuesArray.push(Number(res?.data[key]) - 1);
                    }
                });
                setSelectedValues(valuesArray)
            }
        }));
    }

    useEffect(() => {

        if (questions && questions[currentQuestionIndex]) {
            const questionId = questions[currentQuestionIndex]?.id;

            if (questionId) {
                getQuestionById(questionId);
            }
        }

    }, [currentQuestionIndex, questions]);


    const onClickMultiDelete = () => {
        navigate("/save-servey");
    };


    return (
        <React.Fragment>

            <div className="page-content">
                <div className="container-fluid">

                    <Row>
                        <SaveContinueModal
                            show={openSaveContinueModal}
                            onSaveClick={onClickMultiDelete}
                            onCloseClick={() => setSaveContinueDeleteModal(false)}
                            loading={loading}
                        />
                        <div className="question-form-main">
                            <div className="question-form-inner">
                                <h3><b>{props.t('Institute on Governance')}</b></h3>

                                <div className="ques-progress">
                                    <Progress value={progressBar}>{progressBar?.toFixed(0)}%</Progress>
                                </div>
                                {
                                    questions.length > 0 && currentQuestionIndex < questions.length && (
                                        <React.Fragment>

                                            {
                                                 (horizontalLoading || verticalLoading) 
                                                    ?
                                                    <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                        {props.t("Loading")}
                                                    </div>
                                                    :
                                                    <div className="table-responsive-shadow-box">
                                                        <div className="d-flex"><div className="counting" style={{ marginRight: '5px' }}><strong>{currentQuestionIndex + 1}.</strong></div> <div className="counting-cnt" dangerouslySetInnerHTML={{ __html: questions[currentQuestionIndex]?.text }}></div></div>
                                                        <div className="table-responsive">
                                                            <Table className="table mb-0 question-form-lead lead-action">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="phase-table-width"></th>
                                                                        {
                                                                            horizontalData?.map((data, index) => {
                                                                                return (<th key={index} dangerouslySetInnerHTML={{ __html: data?.text }}></th>)
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {selectedValues.map((selectedColIndex, rowIndex) => (
                                                                        <tr key={rowIndex}>
                                                                            <td dangerouslySetInnerHTML={{ __html: verticalData && verticalData[rowIndex]?.text }}></td>
                                                                            {[0, 1, 2, 3, 4].map((colIndex) => (
                                                                                <td key={colIndex}>
                                                                                    <label className="question-radio">
                                                                                        <input
                                                                                            type="radio"
                                                                                            name={`radio_${rowIndex}`}
                                                                                            value={colIndex}
                                                                                            checked={selectedColIndex === colIndex}
                                                                                            onClick={() => {
                                                                                                handleRadioChange(rowIndex, colIndex);
                                                                                            }}
                                                                                            onChange={() => {
                                                                                                handleRadioChange(rowIndex, colIndex);
                                                                                            }
                                                                                            }
                                                                                        />
                                                                                        <span className="question-radio-click"></span>
                                                                                    </label>
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    ))}
                                                                    <tr>
                                                                        <td colSpan="3">
                                                                            {currentQuestionIndex > 0 && <button className="previous-ques" onClick={handlePrevious}>{props.t('Previous')}</button>}
                                                                            {currentQuestionIndex === 0 && <button className="previous-ques" onClick={() => navigate('/complete-self-servey/phase-ONE')}>{props.t('Previous')}</button>}

                                                                            <button className="save-continue-ques" onClick={saveAnswer}>{props.t('Save to Continue later')}</button>


                                                                            {
                                                                                nextLoading ?

                                                                                    <button disabled className="next-ques">
                                                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}

                                                                                    </button>

                                                                                    :
                                                                                    <button className="next-ques" onClick={handleNext}>{props.t('Next')}</button>

                                                                            }
                                                                        </td>
                                                                        <td>
                                                                        </td>

                                                                        <td>
                                                                        </td>
                                                                        <td>
                                                                        </td>
                                                                        <td></td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                            }
                                        </React.Fragment>

                                    )
                                }
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

PhaseTwo.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(PhaseTwo);
